// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + (chunkId === 265 ? "GazeteSayfasi" : chunkId) + "." + {"265":"ea5c4105","592":"214ed6af","978":"2648a270"}[chunkId] + ".chunk.css";
};